import React from 'react';
import './OwlCTA.scss';
import Owl from '../UI/Graphics/Owl';
import CTAButton from '../UI/CTA/CTAButton/CTAButton';
import Email from '../UI/Icons/Email';
import { COLORS } from '../../constants/colors';
import { getModuleBackgroundColor } from '../../util/getModuleBackgroundColor';

/**
 * Renders the press kit component
 * @param {boolean} isFiltering - determines whether the component should display itself
 * @param {string} backgroundColor - the background color
 * @param {string} title - the title
 * @param {string} ctaText - the cta button text
 * @param {string} ctaLink - the cta button link
 * @param {string} email - the email cta text, el will not render if left blank
 * @param {string} emailUrl - the email cta link
 * @returns {JSX.Element}
 * @constructor
 */
const OwlCTA = ({
  isFiltering = null,
  backgroundColor,
  title,
  ctaText,
  ctaLink,
  email = '',
  emailUrl = null,
}) => {
  const DARK_TYPES = ['white', 'orange', 'gray', 'dark-gray'];

  const isDark = DARK_TYPES.includes(backgroundColor);

  return !isFiltering ? (
    <div className={`c-owl-cta ${getModuleBackgroundColor(backgroundColor)}`}>
      <div className="c-owl-cta__owl-container">
        <Owl />
      </div>
      <div className="c-owl-cta__inner">
        <div className="c-owl-cta__title h4-right-grotesk">
          <h4>{title}</h4>
        </div>
        <div className="c-owl-cta__cta-container ">
          <CTAButton
            type={'secondary'}
            link={ctaLink}
            text={ctaText}
            target={'_blank'}
            additionalClasses={`${isDark ? 'color-black' : 'color-white'} cta`}
          />
        </div>
        {email && (
          <div
            className={`c-owl-cta__email-container text-cta cta ${
              isDark ? 'color-black' : 'color-white'
            }`}
          >
            <a className={`${isDark ? 'color-black' : 'color-white'}`} href={emailUrl}>
              <Email color={isDark ? COLORS.black : COLORS.white} />
              {email}
            </a>
          </div>
        )}
      </div>
    </div>
  ) : null;
};

export default OwlCTA;
